///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.new_vendor = abcsetup.new_vendor || {};
abcsetup.new_vendor.common = abcsetup.new_vendor.common || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.new_vendor.common = {
    dupTimeout: null,

    /**
     * Bind any CRUD fields
     */
    bindFields: function() {
        // Existing vendor lookup field changed
        $('#app_models_vendor__existing_lookup').on('keydown change', function(event) {
            var field = $(this);
            clearTimeout(abcsetup.new_vendor.common.dupTimeout);

            // Enter key was pressed
            if (event.keyCode == 13) {
                event.preventDefault();
                abcsetup.new_vendor.common._checkForDuplicates(field);
                return false;
            }

            abcsetup.new_vendor.common.dupTimeout = setTimeout(function() {
                abcsetup.new_vendor.common._checkForDuplicates(field);
            }, event.type == 'change' ? 0 : 2000);
        });

        abcsetup.new_vendor.common._checkForDuplicates($('#app_models_vendor__existing_lookup'));

        // Country changed
        $('#app_models_vendor_contact_supplier_contact_supplier_contact_country').on('change', function() {
            $('#app_models_vendor_contact_supplier_contact_supplier_contact_zip_code').unmask().attr('placeholder', '')

            // Validate zip codes in the US
            if ($(this).val() == 'US') {
                $('#app_models_vendor_contact_supplier_contact_supplier_contact_zip_code').attr('placeholder', 'XXXXXXXXXX')
            }
        }).trigger('change');

        $('#autocomplete_app_models_vendor__existing_lookup').on('keydown change', function() {
            $('#duplicate_info').remove();
            // Set the hidden field value if nothing was selected
            $('#app_models_vendor__existing_lookup').val($(this).val());
        }).on('blur', function() {
            // Remove the value from the lookup input
            if ($('#duplicate_info').not(':visible')) {
                $('#autocomplete_app_models_vendor__existing_lookup').val('');
            }
        });
    },

    /**
     *  Check for duplicate suppliers using the AB API
     *
     * @param {*} field
     */
    _checkForDuplicates: function(field) {
        field.removeClass('is-valid');
        field.parent().find('.duplicate_msg').remove();

        if (!field.val()) {
            $('.btn-success[name="form_action"]').html('Submit').attr('title', 'Click to Submit');
            return;
        }

        field.parent().append('<small class="duplicate_msg">Checking for duplicate suppliers...</small>');

        axios.get('/api/new_vendor/checkForDuplicates?search=' + field.val()).then(response => {
            field.parent().find('.duplicate_msg').remove();

            if (response.data.response) {
                field.val(response.data.response.vendor_id);
                field.parent().append('<div id="duplicate_info" class="d-flex flex-row mt-2"><small class="duplicate_msg text-warning p-2 font-weight-bold">*Existing Supplier Record Found</small><button type="button" class="btn btn-sm btn-primary" data-toggle="modal" data-target="#duplicate-modal">Duplicate Supplier</button></div>');
                $('#existing_vendor').html(response.data.response.name );

            } else {
                field.addClass('is-valid').parent().append('<small class="duplicate_msg text-success">No Duplicate Supplier(s) Found</small>');
            }

            $("button.disabled").removeClass('disabled').attr('disabled', false);
        });
    },

    /**
     * bootstrap-autocomplete - this is the callback when an item is selected
     */
    autoCompleteSelected: function() {
    },

    /**
     * bootstrap-autocomplete - this is the callback when a free form value is entered
     */
    autoCompleteFreevalue: function() {
    },
}
